import { useIntl } from 'react-intl';

import { testId } from 'ui-components/services/testid-service';

import { CustomsField } from '../customs-field';
import { CustomsTextInput } from '../customs-text-input';
import { messages } from '../messages';

// Must stay in sync with ShipmentPackageProductValidator.MaxCertificateVersionIdLength (SS backend).
const CPSC_CERTIFICATE_FIELD_MAX_LENGTH = 50;

type CpscInputProps = {
  onChange: (newValue: string | number) => void;
  value?: string;
};

export const CustomsCertificateVersionId = ({ onChange, value = '' }: CpscInputProps) => {
  const intl = useIntl();
  return (
    <CustomsField label={messages.certificateVersionIdLabel} recommended>
      <CustomsTextInput
        {...testId('customs-widget-certificate-version-id-input')}
        aria-label={intl.formatMessage(messages.certificateVersionIdLabel)}
        maxLength={CPSC_CERTIFICATE_FIELD_MAX_LENGTH}
        onChange={onChange}
        type='text'
        value={value}
      />
    </CustomsField>
  );
};

export const CustomsCertifierId = ({ onChange, value = '' }: CpscInputProps) => {
  const intl = useIntl();
  return (
    <CustomsField label={messages.certifierIdLabel} recommended>
      <CustomsTextInput
        {...testId('customs-widget-certifier-id-input')}
        aria-label={intl.formatMessage(messages.certifierIdLabel)}
        maxLength={CPSC_CERTIFICATE_FIELD_MAX_LENGTH}
        onChange={onChange}
        type='text'
        value={value}
      />
    </CustomsField>
  );
};
